module.exports = __webpack_public_path__ + "static/media/Fig4.dedc2b73.jpg";